import { mutatorAction } from 'satcheljs';
import store from '../store/Store';

/**
 * Action to update the meetingtype postBuffer in the store.
 */
export default mutatorAction(
    'SET_PBP_MEETING_TYPE_POST_BUFFER',
    function setMeetingPostTypeBuffer(newServiceBuffer: number) {
        store.meetingTypeEditState.postBuffer = newServiceBuffer;
    }
);
